import React from 'react';
import AddressForm from './address-form';

const { UI, Order, Customer, headoffice } = Mobi2Go;

Order.onReady(() => {
    const modal = UI.ExternalModal.create(
        'customer-address-uber-direct',
        <AddressForm
            closeModal={() => {
                modal.close();
            }}
        />,
        {
            'data-view': 'customer-address-uber-direct',
            className:
                'm2g-customer-address m2g-customer-address--uber-direct',
        }
    );

    modal.mount();

    UI.bind('showCustomerAddresses', () => {
        if (
            Order.getLocation().delivery.mode !== 'uber_direct' ||
            Order.getMethod() !== 'delivery'
        ) {
            return;
        }

        if (!Customer.isLoggedIn()) {
            Mobi2Go.UI.trigger('promptProgress');
            return;
        }

        if (Customer.shouldPromptSMSVerification()) {
            return;
        }

        if (!modal.isOpen()) modal.open();
    });
});
